import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-15411ddd"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "booking-calendar" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/images/warning-logo.png",
    alt: "Warning Logo",
    class: "warning-logo mr-4 ml-2"
  }),
  /*#__PURE__*/_createElementVNode("span", { class: "mb-2" }, "警告")
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "grid mt-5 mb-5 justify-content-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "mb-2" }, "予約の変更をお客様へ通知しますか？")
], -1))
const _hoisted_4 = { class: "grid mt-5 mb-5 justify-content-center" }

import { ref, withDefaults, inject, onBeforeMount, watch, computed, nextTick } from "vue";
import moment from "moment";
import Header from "./header.vue";
import Body from "./body.vue";
import { AnyFn, Fn, get, set, useDateFormat, useStorage } from "@vueuse/core";
import { BookingServices } from "@/clinic/services";
import {
  ApiBaseReq,
  ApiBookingIndexReq,
  IBookingPickedTime,
  ApiBookingSaveReq,
  IBooking,
  IBookingResourceEvent,
  IBookingEventFn,
} from "@/clinic/typings";
import { DateSelectArg, EventChangeArg, EventClickArg, EventInput } from "@fullcalendar/core";
import TimeUtils from "@/clinic/utils/time-utils";
import { BookingActionEnum, BookingStatusFull, BookingViewTypeEnum } from "@/clinic/typings/enums/booking";
import { notifySuccessMsg, notityErrorMsg } from "@/clinic/utils/notify-utils";
import { useRouter, useRoute } from "vue-router";
import { DATETIME_ISO_FORMAT, CALENDER_RESOURCES_COUNT } from "@/clinic/typings/constants/booking";
import { FreeSlotServices } from "@/clinic/services";
import { useRouteQuery } from "@vueuse/router";
import { ToastServiceMethods } from "primevue/toastservice";
import _ from "lodash";
import { useStore } from "vuex";
import { ClinicPartner } from "@/clinic/typings/enums/clinic";

type ICalendar = {
  clinicId: number;
  resourcesCount: number;
  toast: ToastServiceMethods;
  slotDuration: string;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    clinicId: { default: 0 },
    resourcesCount: { default: CALENDER_RESOURCES_COUNT },
    toast: null,
    slotDuration: null
  },
  emits: ["resourcesFn", "eventsFn", "exportFn", "showDialogStaffTimeOff"],
  setup(__props: any, { expose, emit: emits }) {

const props = __props as { clinicId: number, resourcesCount: number, toast: ToastServiceMethods, slotDuration: string };

const store = useStore();



const headerCalendar = ref<InstanceType<typeof Header> | null>(null);
const bodyCalendar = ref<InstanceType<typeof Body> | null>(null);

const route = useRoute();
const router = useRouter();

const onShowBookingSidebar = ref<AnyFn>();

const status = ref(BookingStatusFull);
const term = ref("");
const remainingSlots = ref([]);
const refreshClinicBusinessDaySetting = ref("");
const warningNotify = ref(false);
const startTimeChange = ref();
const endTimeChange = ref();
const staffChange = ref();
const oldDataEventChange = ref();
const undoAction = ref(); // This is action from FullCalendar use to undo all change due error, etc
const currentEvent = ref();

const refetchCalendarResources = () => get(bodyCalendar)?.refetchCalendarResources();

// リアクティブなcomputed プロパティとして実装
const isClinicUnaffiliated = computed(() => {
  const selectedClinic = store.getters["authClient/selectedClinic"];
  const partner = selectedClinic?.partner;
  return partner == ClinicPartner.Unaffiliated;
});

let remainingSlotsPromise;
const fetchRemainingSlots = async () => {
  // Vuexストアが完全に初期化されるまで待機
  const selectedClinic = store.getters["authClient/selectedClinic"];
  const hasValidClinic = selectedClinic && selectedClinic.id && selectedClinic.partner !== undefined;

  if (
    get(pickedDate).start != undefined &&
    get(clinicId).value != undefined &&
    hasValidClinic &&
    isClinicUnaffiliated.value
  ) {
    if (!remainingSlotsPromise) {
      const dateString = moment(get(pickedDate).start).format("YYYY-MM-DD");
      remainingSlotsPromise = new Promise((resolve, reject) => {
        FreeSlotServices.fetch(get(clinicId).value, dateString)
          .then(response => {
            const data = response.data.value;
            set(remainingSlots, data);
            resolve(data);
          })
          .catch(error => {
            reject(error);
          });
      });
    }

    remainingSlotsPromise
      .then(slots => {
        set(remainingSlots, slots);
      })
      .catch(errors => {
        console.error("fetchRemainingSlots errors:", errors);
      });
  }
};

const setStatus = (newStatus: string) => set(status, newStatus);

const setTerm = (newTerm: string) => set(term, newTerm);

/**
 * カレンダーに新しい予約イベントを追加する
 *
 * @function
 * @param {EventInput} event - 追加するイベント情報
 * @returns {void}
 * @description
 * - イベントの日付が休業日の場合は処理を中止
 * - 予約サイドバーを表示するための関数を取得し、新規予約フォームを表示
 */
const addEvent = (event: EventInput) => {
  const resourceId = event.resource?.id;
  const isFreeSpace = resourceId.endsWith("fs");
  const { start } = event.resource._context.dateSelection.range;
  const offDays = get(get(bodyCalendar)?.offDays);
  if (offDays?.includes(start.getDay())) return;

  const showBookingSidebarFn =
    get(onShowBookingSidebar) ||
    ((_booking: IBooking, _action: string, _eventArg: EventClickArg | EventInput) => ({
      _booking,
      _action,
      _eventArg,
    }));
  showBookingSidebarFn({ is_free_space: isFreeSpace } as IBooking, BookingActionEnum.new, event);
};

const revertCurrentChange = () => {
  undoAction.value();
  set(warningNotify, false);
};

const handleChangeBooking = async (notify: boolean) => {
  const {
    customerId: customer_id,
    customerName: customer_name,
    note_symptom: old_note_symptom,
    medicalMenuCategoryId: medical_menu_category_id,
    medicalMenuId: medical_menu_id,
    medicalOptionIds: medical_option_ids,
    reservationId: id,
    note,
    bookingType: booking_type,
    bookingRequestId: booking_request_id,
    roomId: room_id,
    isFreespace: is_free_space,
  } = get(oldDataEventChange);
  if (_.isArray(id)) {
    return;
  } // to do remove later - wiew week update multiple event bookings

  // 現在のイベントからnote_symptomを取得（新規作成直後の場合の対策）
  const currentEventExtendedProps = get(currentEvent)?.extendedProps;
  const note_symptom = currentEventExtendedProps?.note_symptom || old_note_symptom || "";

  const payload = {
    customer_id,
    note_symptom,
    customer_name,
    medical_menu_category_id,
    medical_menu_id,
    medical_option_ids,
    note,
    booking_type,
    start_time: get(useDateFormat(new Date(get(startTimeChange)?.getTime()), DATETIME_ISO_FORMAT)),
    end_time: get(useDateFormat(new Date(get(endTimeChange)?.getTime()), DATETIME_ISO_FORMAT)),
    staff_id: String(get(staffChange)).endsWith("fs") ? String(get(staffChange)).replace(/fs$/, "") : get(staffChange),
    notify: notify,
    booking_request_id,
    room_id,
    is_free_space,
  } as unknown as ApiBookingSaveReq;

  await BookingServices.saveBooking(
    { id, clinic_id: props.clinicId || store.getters["authClient/selectedClinic"].id },
    payload,
    () => {
      get(currentEvent).source?.refetch();
      notifySuccessMsg(get(props.toast), "保存成功");
      reFetchRemainningSlot();
    },
    errors => {
      notityErrorMsg(get(props.toast), errors.response.data.errors || errors.response.data.error);
      undoAction.value();
    }
  );

  set(warningNotify, false);
};

const changeBookingWithNotify = () => {
  handleChangeBooking(true);
};

const changeBookingWithOutNotify = () => {
  handleChangeBooking(false);
};

const changeEvent = async ({ event, oldEvent, revert }: EventChangeArg) => {
  const { end, start } = event;
  const { end: oldEnd, start: oldStart, extendedProps } = oldEvent;
  const [staff] = event.getResources();
  const [oldStaff] = oldEvent.getResources();
  if (staff.id == oldStaff.id && end?.getTime() == oldEnd?.getTime() && start?.getTime() == oldStart?.getTime()) {
    return;
  }

  // 自由予約と通常予約間のドロップを制御
  const isFromFreeSpace = oldStaff.id.endsWith("fs");
  const isToFreeSpace = staff.id.endsWith("fs");
  const isFromNormalSpace = !oldStaff.id.endsWith("fs");
  const isToNormalSpace = !staff.id.endsWith("fs");

  // 自由予約から通常予約レーンへのドロップの場合はエラーを表示
  if (isFromFreeSpace && isToNormalSpace) {
    notityErrorMsg(get(props.toast), "自由予約の情報を通常の予約に変更はできません");
    revert();
    return;
  }

  // 通常予約から自由予約レーンへのドロップの場合もエラーを表示
  if (isFromNormalSpace && isToFreeSpace) {
    notityErrorMsg(get(props.toast), "通常の予約を自由予約に変更はできません");
    revert();
    return;
  }

  // 自由予約の場合は確認ダイアログを表示せずに通知なしで保存
  if (staff.id.endsWith("fs")) {
    set(currentEvent, event);
    set(startTimeChange, start);
    set(endTimeChange, end);
    set(staffChange, staff.id);
    set(oldDataEventChange, extendedProps);
    set(undoAction, revert);
    handleChangeBooking(false); // 通知しない
    return;
  }

  set(currentEvent, event);
  set(warningNotify, true);
  set(startTimeChange, start);
  set(endTimeChange, end);
  set(staffChange, staff.id);
  set(oldDataEventChange, extendedProps);
  set(undoAction, revert);
};

// sessionStorageのキーを定義
const STORAGE_KEY = "booking-calendar-date";


const onPrev = async (prevDate: IBookingPickedTime) => {
  set(refreshClinicBusinessDaySetting, prevDate);
  set(pickedDate, prevDate);
  // sessionStorageに日付を保存
  sessionStorage.setItem(STORAGE_KEY, prevDate.start.toISOString());

  // 週表示でもイベントを確実に再取得
  nextTick(() => {
    get(bodyCalendar)?.loadEvents();
  });

  reFetchRemainningSlot();
};
const onNext = async (nextDate: IBookingPickedTime) => {
  set(refreshClinicBusinessDaySetting, nextDate);
  set(pickedDate, nextDate);
  // sessionStorageに日付を保存
  sessionStorage.setItem(STORAGE_KEY, nextDate.start.toISOString());

  // 週表示でもイベントを確実に再取得
  nextTick(() => {
    get(bodyCalendar)?.loadEvents();
  });

  reFetchRemainningSlot();
};
const onToday = async (today: IBookingPickedTime) => {
  set(refreshClinicBusinessDaySetting, today);
  set(pickedDate, today);
  // sessionStorageに日付を保存
  sessionStorage.setItem(STORAGE_KEY, today.start.toISOString());

  // 週表示でもイベントを確実に再取得
  nextTick(() => {
    get(bodyCalendar)?.loadEvents();
  });

  reFetchRemainningSlot();
};
const onChangeViewType = (view_type: BookingViewTypeEnum, pickedTime: IBookingPickedTime) => {
  set(viewType, view_type);
  set(pickedDate, pickedTime);
  // sessionStorageに日付を保存（表示モード切替時も保存）
  sessionStorage.setItem(STORAGE_KEY, pickedTime.start.toISOString());

  // 日付切り替えと同じ処理でイベントを確実に再取得
  nextTick(() => {
    get(bodyCalendar)?.loadEvents();
  });

  reFetchRemainningSlot();
  // Todo: set link clinic/bookings?view_type=Week / Day
  // const query = { view_type };
  // router.replace({ query });
};
const isInitializing = ref(true);

const onChangeDate = ({ start, view: { type } }: DateSelectArg) => {
  // 初期化中はFullCalendarの自動的なdatesSetイベントを無視
  if (get(isInitializing)) {
    const savedDate = sessionStorage.getItem(STORAGE_KEY);

    if (savedDate) {
      const savedDateTime = new Date(savedDate);
      const startDateTime = new Date(start);
      const currentPickedDate = get(pickedDate).start;

      // sessionStorageから復元した日付が存在し、現在のpickedDateが保存された日付と一致している場合、
      // FullCalendarが別の日付に変更しようとした時のみ無視
      if (
        currentPickedDate &&
        savedDateTime.toDateString() === currentPickedDate.toDateString() &&
        startDateTime.toDateString() !== savedDateTime.toDateString()
      ) {
        return;
      }
    }
  }

  let end = start;
  if (type.replace("resourceTimeline", "") == BookingViewTypeEnum.Day) end = TimeUtils.toEndWeekDate(start);
  set(pickedDate, { start, end } as IBookingPickedTime);
  // sessionStorageに日付を保存
  sessionStorage.setItem(STORAGE_KEY, start.toISOString());
};

watch(
  () => store.state.booking.headerBookingDetails,
  newValue => {
    const id = newValue["booking_id"];
    const start = new Date(newValue["start_time"]);
    const end = start;
    if (start && !isNaN(start.getTime())) {
      set(pickedDate, { start, end } as IBookingPickedTime);
    }
    const showBookingSidebarFn =
      get(onShowBookingSidebar) ||
      ((_booking: IBooking, _action: string, _eventArg: EventClickArg | EventInput) => ({
        _booking,
        _action,
        _eventArg,
      }));
    showBookingSidebarFn({ id } as IBooking, BookingActionEnum.show, {} as EventClickArg);
  }
);

const reFetchRemainningSlot = () => {
  if (viewType.value == BookingViewTypeEnum.Week) return;

  remainingSlotsPromise = null;
  fetchRemainingSlots();
};

const onSelect = (evt: Event) => addEvent(evt);

const onEventChange = (event: EventChangeArg) => changeEvent(event);

const onFilter = async (source: { [key: string]: string }, form: HTMLFormElement) => {
  const formData = new FormData(form);
  await setStatus(source["status"] ? source["status"] : (formData?.get("status") as string));
  await setTerm(source["term"] ? source["term"] : (formData?.get("term") as string));
  const loadEventsFn = get(bodyCalendar)?.loadEvents || (() => undefined);
  await loadEventsFn();
};

// Todo: get link clinic/bookings?view_type=Week / Day
// const viewTypeQuery = computed(
//   (): BookingViewTypeEnum => get(useRouteQuery("view_type", BookingViewTypeEnum.Day, { route, router }))
// );

// const viewType = ref<BookingViewTypeEnum>(get(viewTypeQuery));
const viewType = ref<BookingViewTypeEnum>(BookingViewTypeEnum.Day);

const getInitialPickedDate = (): IBookingPickedTime => {
  // sessionStorageから保存された日付を取得
  const savedDate = sessionStorage.getItem(STORAGE_KEY);

  if (savedDate) {
    // 保存された日付がある場合はその日付を使用（ブラウザリロード時）
    const date = new Date(savedDate);
    // ローカル日付として正しく処理するため、YYYY-MM-DD形式に直接変換
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const dateYMD = `${year}-${month}-${day}`;

    const result =
      get(viewType) == BookingViewTypeEnum.Week ? TimeUtils.weekToday(date) : TimeUtils.dateToRangeTime(dateYMD);
    return result;
  }

  // 保存された日付がない場合は当日を使用（初回表示時）
  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, "0");
  const day = String(today.getDate()).padStart(2, "0");
  const todayYMD = `${year}-${month}-${day}`;

  return get(viewType) == BookingViewTypeEnum.Week ? TimeUtils.weekToday() : TimeUtils.dateToRangeTime(todayYMD);
};

const pickedDate = ref<IBookingPickedTime>(getInitialPickedDate());

const clinicId = ref(0);

// 基本設定からshow_free_spaceを取得
const bookingSettings = computed(() => store.state.bookingSetting?.bookingSetting);
const isShowFreeSpaceEnabled = computed(() => bookingSettings.value?.show_free_space !== false);

// 初期値を基本設定から決定（基本設定がOFFの場合は強制的にfalse）
// sessionStorageで状態を永続化し、ブラウザリロード時も状態を維持
const showFreeSpace = useStorage("showFreeSpaceBooking", isShowFreeSpaceEnabled.value, sessionStorage);

const setClinicId = async () => set(clinicId, await inject("clinicId"));

// refreshClinicBusinessDaySettingを初期日付で設定
set(refreshClinicBusinessDaySetting, get(pickedDate).start);

const clinicIdParams = async (): Promise<ApiBaseReq> => ({ clinic_id: get(await get(clinicId)) });

const bookingParams = async ({ start: start_time, end: end_time }: IBookingPickedTime): Promise<ApiBookingIndexReq> => {
  return {
    ...(await clinicIdParams()),
    start_time,
    end_time,
    term: get(term),
    status: get(status),
    view_type: get(viewType),
  } as ApiBookingIndexReq;
};

const onResourcesFn = (event: IBookingResourceEvent) => {
  // Pass showFreeSpace state to the resourcesFn event
  emits("resourcesFn", { ...event, showFreeSpace: showFreeSpace.value });
};

const onEventsFn = (event: IBookingEventFn) => emits("eventsFn", event, bookingParams);

const onExport = (event: Event) => emits("exportFn", event, get(pickedDate), bookingParams);

const showDialogStaffTimeOff = (data: unknown) => emits("showDialogStaffTimeOff", data);

const onDateSelect = (date: Date) => {
  remainingSlotsPromise = null;
  fetchRemainingSlots();
  set(refreshClinicBusinessDaySetting, date);
  set(pickedDate, { start: date, end: date });
  // sessionStorageに日付を保存
  sessionStorage.setItem(STORAGE_KEY, date.toISOString());
};

const onToggleFreeSpace = (value: boolean) => {
  set(showFreeSpace, value);
  // Refresh resources to apply the filter
  refetchCalendarResources();
};

const loadShowSidebar = () => {
  const id = get(useRouteQuery("booking_id", 0, { route, router, transform: Number }));
  if (id == 0) return;

  const showBookingSidebarFn =
    get(onShowBookingSidebar) ||
    ((_booking: IBooking, _action: string, _eventArg: EventClickArg | EventInput) => ({
      _booking,
      _action,
      _eventArg,
    }));
  showBookingSidebarFn({ id } as IBooking, BookingActionEnum.show, {} as EventClickArg);
};

const loadInitComponents = async () => {
  set(onShowBookingSidebar, inject<Fn>("onShowBookingSidebar"));
  await setClinicId();
  loadShowSidebar();
};

const setTotalCustomersBooked = data => {
  get(bodyCalendar)?.setTotalCustomersBooked(data);
};

// selectedClinicの状態変化を監視
watch(
  () => store.getters["authClient/selectedClinic"],
  (newClinic, oldClinic) => {
    if (newClinic && newClinic.partner !== undefined) {
      // sessionStorageクリア後の画面遷移復帰時は少し遅延を加えて確実に実行
      nextTick(() => {
        fetchRemainingSlots();
      });
    }
  },
  { immediate: true }
);

// 基本設定の変更を監視
watch(
  () => store.state.bookingSetting?.bookingSetting?.show_free_space,
  newValue => {
    if (newValue === false) {
      // 基本設定でOFFになった場合は強制的にfalse
      set(showFreeSpace, false);
      refetchCalendarResources();
    }
    // 基本設定がONの場合は、ユーザーの選択（sessionStorageの値）を維持
  }
);

onBeforeMount(async () => {
  // ブラウザリロードか遷移かを精密に判定
  const navigationEntry = performance.getEntriesByType("navigation")[0] as PerformanceNavigationTiming;
  const currentPath = route.path;

  if (
    navigationEntry &&
    navigationEntry.type !== "reload" &&
    // 同一パス内での移動（タブ切り替え）は除外
    window.history.length > 1 &&
    // 予約カレンダー内のタブ切り替えではない場合のみクリア
    !(currentPath === "/clinic/bookings" && route.query.view_page)
  ) {
    // 外部からの遷移時のみsessionStorageをクリア
    sessionStorage.removeItem(STORAGE_KEY);
  }

  await loadInitComponents();

  const paramsQuery = route.query;
  const paramsStartTime = paramsQuery["start_time"];
  if (paramsStartTime) {
    const start = new Date(paramsStartTime);
    const end = start;
    set(pickedDate, { start: start, end: end });
    // URLパラメータから日付を設定した場合もsessionStorageに保存
    sessionStorage.setItem(STORAGE_KEY, start.toISOString());
  }

  // 初期化完了後、通常の日付変更を許可
  setTimeout(() => {
    set(isInitializing, false);
  }, 1000); // 1秒後に初期化完了とする
});

// eslint-disable-next-line no-undef
expose({
  setTotalCustomersBooked,
  reFetchRemainningSlot,
  refetchCalendarResources,
});

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(Header, {
        ref_key: "headerCalendar",
        ref: headerCalendar,
        pickedDate: pickedDate.value,
        viewType: viewType.value,
        switchView: _unref(isClinicUnaffiliated),
        showFreeSpace: _unref(showFreeSpace),
        onPrev: onPrev,
        onNext: onNext,
        onToday: onToday,
        onChangeViewType: onChangeViewType,
        onFilter: onFilter,
        onExport: onExport,
        onDateSelect: onDateSelect
      }, null, 8, ["pickedDate", "viewType", "switchView", "showFreeSpace"]),
      _createVNode(Body, {
        ref_key: "bodyCalendar",
        ref: bodyCalendar,
        clinicId: props.clinicId,
        pickedDate: pickedDate.value,
        viewType: viewType.value,
        remainingSlots: remainingSlots.value,
        slotDuration: props.slotDuration,
        refreshClinicBusinessDaySetting: refreshClinicBusinessDaySetting.value,
        showFreeSpace: _unref(showFreeSpace),
        onSelect: onSelect,
        onChangeDate: onChangeDate,
        onEventChange: onEventChange,
        onResourcesFn: onResourcesFn,
        onEventsFn: onEventsFn,
        onShowDialogStaffTimeOff: showDialogStaffTimeOff,
        onToggleFreeSpace: onToggleFreeSpace
      }, null, 8, ["clinicId", "pickedDate", "viewType", "remainingSlots", "slotDuration", "refreshClinicBusinessDaySetting", "showFreeSpace"])
    ]),
    _createVNode(_component_Dialog, {
      visible: warningNotify.value,
      "onUpdate:visible": [
        _cache[0] || (_cache[0] = ($event: any) => ((warningNotify).value = $event)),
        revertCurrentChange
      ],
      modal: "",
      style: { width: '550px' },
      class: "mx-5 dialog-note border-0"
    }, {
      header: _withCtx(() => [
        _hoisted_2
      ]),
      default: _withCtx(() => [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_Button, {
            class: "col-3 black-btn ml-5",
            label: "キャンセル",
            onClick: revertCurrentChange
          }),
          _createVNode(_component_Button, {
            class: "col-3 black-btn ml-5",
            label: "通知しない",
            onClick: changeBookingWithOutNotify
          }),
          _createVNode(_component_Button, {
            class: "col-3 create-btn ml-5",
            label: "今すぐ通知",
            onClick: changeBookingWithNotify
          })
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}
}

})